export default {
  title: 'Utilisateurs',
  subtitle: 'Liste des utilisateurs',
  create: 'Ajouter un utilisateur'
}
